module.exports = {
      id: "parceiros-error-usage",
      viewBox: "0 0 46 57",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#parceiros-error",
      toString: function () {
        return this.url;
      }
    }